import runAnimations from "./runAnimations";
import { getCommonStyle } from "./utils";
const checkAnimations = ({ doRunAnimations, callback, $el, animationList }) => {
  if (doRunAnimations) {
    runAnimations($el, animationList, false, callback);
  } else {
    callback && callback();
  }
};
const showOrHide = async (elemId, type) => {
  document.getElementById(elemId) &&
    (document.getElementById(elemId).style.display = type);
};
const setSize = (elemId, { width, height, scalingRatio, elemDefault }) => {
  const style = getCommonStyle({ width, height }, scalingRatio);
  const styleDefault = getCommonStyle(
    {
      width: elemDefault.commonStyle.width,
      height: elemDefault.commonStyle.height,
    },
    scalingRatio
  );
  const elem = document.getElementById(elemId);
  if (elem) {
    const transformX =
      (parseFloat(styleDefault.width.replace("px")) -
        parseFloat(style.width.replace("px"))) /
      2;
    const transformY =
      (parseFloat(styleDefault.height.replace("px")) -
        parseFloat(style.height.replace("px"))) /
      2;
    elem.style.transition = "all 0.3s ease-in-out";
    elem.style.transform = `translateX(${transformX}px) translateY(${transformY}px)`;
    elem.style.width = style.width;
    elem.style.height = style.height;
  }
};
const setZIndex = (elemId, { zIndex }) => {
  const elem = document.getElementById(elemId);
  if (elem) {
    !window.maxZIndex && (window.maxZIndex = 999);
    if (zIndex == 1) {
      elem.style.zIndex = ++window.maxZIndex;
    } else if (zIndex == 2) {
      elem.style.zIndex = 0;
    }
  }
};
const eventFunc = ({ eventData, _this, resolve }) => {
  console.log(eventData, "eventFunc");
  console.log("🚀 ~ eventFunc ~ eventData.action:", eventData.action);
  switch (eventData.action) {
    case "show":
      eventData.elementUUIDs &&
        eventData.elementUUIDs.map((i) => {
          if (i.isGroup) {
            _this.$nextTick(() => {
              showOrHide(i.uuid, "block");
              i.list.map((m) => {
                showOrHide(m.uuid, "block");
              });
            });
          } else {
            _this.$nextTick(() => {
              showOrHide(i.uuid, "block");
            });
          }
        });
      resolve();
      break;
    case "hide":
      eventData.elementUUIDs &&
        eventData.elementUUIDs.map((i) => {
          const animationFunc = (item, origin, callback) => {
            const animationsOut = origin.animations.filter(
              (z) => z.type.toLowerCase().indexOf("out") > -1
            );
            if (animationsOut && animationsOut.length > 0) {
              checkAnimations({
                doRunAnimations: 1,
                callback: () => callback(item, origin),
                $el: document.getElementById(item.uuid),
                animationList: animationsOut,
              });
            } else {
              callback && callback(item, origin);
            }
          };
          const getOrigin = (item) => {
            const element = _this.elementsAll.find((m) => m.uuid == item.uuid);
            if (element) {
              return element;
            }
            const elementGroups = _this.elementGroups.find(
              (i) => i.uuid == item.uuid
            );
            if (elementGroups) {
              return elementGroups;
            }
            return { animations: [] };
          };
          animationFunc(i, getOrigin(i), (item) => {
            if (item.isGroup) {
              _this.$nextTick(() => {
                showOrHide(item.uuid, "none");
                i.list.map((m) => {
                  animationFunc(m, getOrigin(m), (y) => {
                    _this.$nextTick(() => {
                      showOrHide(y.uuid, "none");
                    });
                  });
                });
              });
            } else {
              _this.$nextTick(() => {
                showOrHide(item.uuid, "none");
              });
            }
          });
        });
      resolve();
      break;
    case "wait":
      setTimeout(() => {
        resolve();
      }, eventData.millisecond);
      break;
    case "link":
      // window.open(eventData.url)
      _this.$utils.parentPostMessage({
        type: "JUMP_LINK",
        url: eventData.url,
      });
      location.href = eventData.url;
      resolve();
      break;
    case "router":
      if (_this.changeRouter) {
        _this.changeRouter(eventData.pageUUID);
      } else {
        _this.$emit("router", eventData.pageUUID);
      }
      resolve();
      break;
    case "dynamicPanel":
      // console.log(111, "get-dynamicPanel");
      window.dynamicPanelStateChange(eventData);
      // _this.$emit("dynamicPanelStateChange", eventData);
      resolve();
      break;
    case "setSize":
      setSize(eventData.elementUUIDs[eventData.elementUUIDs.length - 1].uuid, {
        width: eventData.setWidth,
        height: eventData.setHeight,
        scalingRatio: _this.scalingRatio,
        elemDefault: _this.elementsAll.find(
          (m) =>
            m.uuid ==
            eventData.elementUUIDs[eventData.elementUUIDs.length - 1].uuid
        ),
      });
      resolve();
      break;
    case "setZIndex":
      setZIndex(
        eventData.elementUUIDs[eventData.elementUUIDs.length - 1].uuid,
        {
          zIndex: eventData.setZIndex,
        }
      );
      resolve();
      break;
    case "setBackgroundMusic":
      if (eventData.setBackgroundMusic == 1) {
        // 背景音乐开启
        window.bgMusicPlay();
      } else if (eventData.setBackgroundMusic == 2) {
        // 背景音乐关闭
        window.bgMusicPause();
      }
      resolve();
      break;
    case "wxMiniProgramNavigateTo":
      try {
        if (!eventData.parmas.AppId) {
          window.wx.miniProgram.navigateTo({
            url: eventData.parmas.path,
          });
        } else {
          const query = `?toAppId=${
            eventData.parmas.AppId
          }&toPath=${encodeURIComponent(eventData.parmas.path)}`;
          console.log(parent == window);
          if (parent == window) {
            window.wx.miniProgram.navigateTo({
              url: "../externalLinkToMini/externalLinkToMini" + query,
            });
          } else {
            window.parent.postMessage(
              {
                type: "JUMP_MINIPROGRAM",
                data: {
                  query,
                },
              },
              "*"
            );
          }
        }
      } catch (E) {
        console.log("跳转失败", e);
      }
      break;
  }
};
/**
 *  元素动作相关方法
 * */
export default {
  methods: {
    /**
     * 单击时
     */
    _event_click(eventData, _this) {
      return new Promise((resolve) => {
        eventFunc({ eventData, _this, resolve });
      });
    },
    /**
     * 载入时
     */
    _event_load(eventData, _this) {
      return new Promise((resolve) => {
        eventFunc({ eventData, _this, resolve });
      });
    },
  },
};
